import {
  SET_FILTERS,
  SET_TABLE_SETTINGS,
  APPLY_PRESET,
  CHANGE_LOCATION,
} from '@gogame/screens';

import { COLUMN_DIMENSION, COLUMN_REGS } from '../constants';
import { tableSettingsSchema, drillPathSchema } from '../schemas';
import { isHourDimension, isRootHourDimension } from '../utils';
import {
  drillPathReducer,
  DRILL_DOWN,
  SET_DRILL_PATH,
  SET_DIMENSION,
} from './drillPathReducer';
import {
  hourlyTrackerChartsReducer,
  SET_CHART_METRICS,
  ADD_CHART,
  REMOVE_CHART,
} from './hourlyTrackerChartsReducer';
import {
  columnReducer,
  SET_COLOR_SCALES_ALL_COLUMNS,
  SET_COLOR_SCALES_COLUMNS,
  SET_COLUMNS,
  REORDER_COLUMNS,
  COLLAPSE_COLUMNS,
  TOGGLE_COLUMN_PERCENTAGE,
} from './columnReducer';

export {
  SET_FILTERS,
  SET_TABLE_SETTINGS,
  APPLY_PRESET,
  CHANGE_LOCATION,
  SET_COLOR_SCALES_ALL_COLUMNS,
  SET_COLOR_SCALES_COLUMNS,
  SET_COLUMNS,
  REORDER_COLUMNS,
  COLLAPSE_COLUMNS,
  TOGGLE_COLUMN_PERCENTAGE,
};
export const APPLY = 'APPLY';

export function hourlyTrackerReducer(state = { ready: false }, action) {
  switch (action.type) {
    case APPLY: {
      return {
        ...action.payload,
      };
    }
    case CHANGE_LOCATION: {
      return { ...action.payload };
    }
    // columns
    case SET_COLUMNS: {
      return ensureSorting({
        ...state,
        columns: columnReducer(state.columns, action),
      });
    }
    case COLLAPSE_COLUMNS:
    case SET_COLOR_SCALES_ALL_COLUMNS:
    case SET_COLOR_SCALES_COLUMNS:
    case REORDER_COLUMNS:
    case TOGGLE_COLUMN_PERCENTAGE:
      return {
        ...state,
        columns: columnReducer(state.columns, action),
      };

    case ADD_CHART:
    case REMOVE_CHART:
    case SET_CHART_METRICS: {
      return {
        ...state,
        ready: true,
        charts: hourlyTrackerChartsReducer(state.charts, action),
      };
    }

    case SET_FILTERS:
      const { type } = state.drillPath[0];

      return {
        ...state,
        // reset table settings on changing filters
        ready: true,
        tableSettings: {
          ...state.tableSettings,
          offset: 0,
        },
        drillPath: isRootHourDimension(type)
          ? drillPathSchema.default()
          : state.drillPath,
        filtersCollection: action.payload,
      };

    case SET_TABLE_SETTINGS:
      return {
        ...state,
        tableSettings: { ...state.tableSettings, ...action.payload },
      };

    case SET_DRILL_PATH:
    case DRILL_DOWN:
    case SET_DIMENSION:
      const isDimensionSort = state.tableSettings.orderBy === COLUMN_DIMENSION;
      const drillPath = drillPathReducer(state.drillPath, action);

      let tableSettings = {
        ...state.tableSettings,
        offset: 0,
      };

      const dimension = drillPath.slice(-1).pop().type;
      if (isHourDimension(dimension)) {
        tableSettings = {
          ...tableSettingsSchema.default(),
          limit: tableSettings.limit,
        };
      } else if (isDimensionSort) {
        tableSettings = {
          ...tableSettingsSchema.default(),
          orderBy: COLUMN_REGS,
          orderDir: 'desc',
          limit: tableSettings.limit,
        };
      }

      return ensureSorting({
        ...state,
        drillPath,
        tableSettings,
      });

    default:
      return state;
  }
}

function ensureSorting(state) {
  const order = state.columns.order;
  const orderBy = state.tableSettings.orderBy;
  if ([COLUMN_DIMENSION, ...order].includes(orderBy)) {
    return state;
  }

  return {
    ...state,
    tableSettings: {
      ...state.tableSettings,
      orderBy: order[0], //sort by first column
      orderDir: 'desc',
      offset: 0,
    },
  };
}
